import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ColorPicker from 'src/components/Modules-revamp/ColorPicker';
import { Field } from 'src/components/RcForm';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import {
  backgroundColor,
  bodyTextColor,
  listPriceColor,
  moduleText,
  otherPriceColor,
  productNameColor,
} from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import { EnumModuleType } from 'src/types/common/module';
const Text = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { moduleType } = props;
  const productNameTextDisplay =
    moduleType === EnumModuleType.ResponsiveProductCarousel ||
    moduleType === EnumModuleType.ResponsiveProductGrid;

  return (
    <Section {...sectionProps}>
      <ItemWrapper title={getI18n('general.backgroundColour')}>
        <Field name={[moduleText, backgroundColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      {productNameTextDisplay && (
        <ItemWrapper title={getI18n('general.productNameColour')}>
          <Field name={[moduleText, productNameColor]}>
            <ColorPicker disabled={props.disabled} />
          </Field>
        </ItemWrapper>
      )}

      <ItemWrapper title={getI18n('general.bodyTextColour')}>
        <Field name={[moduleText, bodyTextColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.listPriceColour')}>
        <Field name={[moduleText, listPriceColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
      <ItemWrapper title={getI18n('general.otherPriceColour')}>
        <Field name={[moduleText, otherPriceColor]}>
          <ColorPicker disabled={props.disabled} />
        </Field>
      </ItemWrapper>
    </Section>
  );
};
export default Text;
